import { Injectable } from '@angular/core'
import {
  EventService,
  LoginEvent,
  OCC_USER_ID_CURRENT,
  QueryService,
  UserIdService
} from '@spartacus/core'
import { UserAccountConnector, UserAccountService } from '@spartacus/user/account/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { map, switchMap } from 'rxjs/operators'
import { EbUserInterface } from '../interface/eb-user.interface'

@Injectable({
  providedIn: 'root'
})
export class EbUserAccountService extends UserAccountService {
  _userData$ = new BehaviorSubject(undefined)

  constructor(
    protected userAccountConnector: UserAccountConnector,
    protected userIdService: UserIdService,
    protected queryService: QueryService,
    protected eventService: EventService
  ) {
    super(userAccountConnector, userIdService, queryService)
    this.eventService
      .get(LoginEvent)
      .pipe(
        switchMap(() => this.userAccountConnector.get(OCC_USER_ID_CURRENT)),
        map(user => {
          const ebUser = user as EbUserInterface
          this.setEbActiveUserData(ebUser)
        })
      )
      .subscribe()
  }

  getEbActiveUserData(): Observable<EbUserInterface> {
    return this._userData$
  }

  setEbActiveUserData(userData: EbUserInterface | undefined) {
    this._userData$.next(userData)
  }
}
